export default {
  selectedTab: null
}
